import api from "../api";

class ModifierCodeService {
  async getAllModifierCodes() {
    return new Promise((res, reject) => {
      api
        .get("/modifierCode")
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async getModifierCodeById(id) {
    return new Promise((res, reject) => {
      api
        .get("/modifierCode/" + id)
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async createModifierCode(obj) {
    return new Promise((res, reject) => {
      api
        .post("/modifierCode", obj)
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async updateModifierCode(obj) {
    return new Promise((res, reject) => {
      api
        .put("/modifierCode", obj)
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async deleteModifierCode(id) {
    return new Promise((res, rej) => {
      return api
        .delete("/modifierCode/" + id)
        .then((data) => {
          res();
        })
        .catch((err) => {
          rej();
        });
    });
  }
}

const modifierCodeService = new ModifierCodeService();

export default modifierCodeService;
